"use strict";

(function () {
  "use strict";

  angular.module("pageIframe", ["ui.router", "common"]);
})();